import { NgTemplateOutlet } from "@angular/common";
import { Component, HostBinding, Input } from "@angular/core";
import { Router, RouterLink } from "@angular/router";
import { isString } from "lodash-es";
import { Permission } from "src/app/core/auth";
import { IfHasPermissionDirective } from "src/app/core/auth/if-has-permission.directive";

@Component({
  selector: "mr-link",
  template: `
    @if (permission) {
      <ng-container
        *mrIfHasPermission="permission; then linkedContent; else content"
      ></ng-container>
    } @else {
      <ng-container [ngTemplateOutlet]="linkedContent"></ng-container>
    }

    <ng-template #linkedContent>
      <a
        [routerLink]="link"
        [queryParams]="params"
        [state]="{ returnTo: returnTo }"
        ><ng-container [ngTemplateOutlet]="content"></ng-container
      ></a>
    </ng-template>

    <ng-template #content><ng-content></ng-content></ng-template>
  `,
  styles: [
    `
      :host.important a {
        color: var(--mr-color-blue);
      }
    `,
  ],
  imports: [IfHasPermissionDirective, RouterLink, NgTemplateOutlet],
})
export class LinkComponent {
  @Input() public link: RouterLink["routerLink"] = ".";
  @Input() public params: RouterLink["queryParams"] = {};
  @Input() public permission?: Permission;
  @Input() public returnTo = window.location.href.replace(
    window.location.origin,
    "",
  );
  @Input() @HostBinding("class") public kind?: "important";
}

export function getReturnLink(
  router: Router,
  { defaultLink }: { defaultLink?: string } = {},
): string {
  const state = router.currentNavigation()?.extras.state;
  return state && isString(state["returnTo"]) && state["returnTo"].length > 0
    ? state["returnTo"]
    : (defaultLink ?? "..");
}
